import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import CurrencyConverter from '../CurrencyConverter';
import ToolTipSection from '../Common/ToolTipSection/ToolTipSection';

import messages from '../../locale/jsonMessages';
import dayDifferenceHelper from '../../helpers/dayDifferenceHelper';
import { getPromoCodeDetailsValue } from '../../helpers/GetDynamicItemName/dynamicHomeValue';

import cs from '../commonStyle.css';
import s from './Payment.css';



class PaymentDetails extends Component {
	static propTypes = {
		checkIn: PropTypes.string.isRequired,
		checkOut: PropTypes.string.isRequired,
		total: PropTypes.number.isRequired,
		basePrice: PropTypes.number.isRequired,
		delivery: PropTypes.number.isRequired,
		discount: PropTypes.number,
		discountType: PropTypes.string,
		serviceFee: PropTypes.number.isRequired,
		currency: PropTypes.string.isRequired,
		formatMessage: PropTypes.any,
	};

	render() {
		const { formatMessage, locale } = this.props.intl;
		const { checkIn, checkOut, basePrice, delivery, total, securityDeposit, bookingSpecialPricing } = this.props;
		const { discount, discountType, serviceFee, currency, startTime, endTime } = this.props;
		const { promoCode, promoDiscount, promoCodeDescription, dynamicPromoCodeDetails } = this.props;
		let momentStartDate, momentEndDate, dayDifference, priceForDays = 0, isAverage = 0, isDayTotal, isSpecialPriceAssigned, value;

		isSpecialPriceAssigned = (bookingSpecialPricing && bookingSpecialPricing.length > 0) ? true : false;

		if (checkIn != null && checkOut != null) {
			momentStartDate = moment(parseInt(checkIn));
			momentEndDate = moment(parseInt(checkOut));
			dayDifference = momentEndDate.diff(momentStartDate, 'days');
			dayDifference = dayDifferenceHelper({ startDate: momentStartDate, endDate: momentEndDate, startTime, endTime });

			if (isSpecialPriceAssigned) {
				bookingSpecialPricing && bookingSpecialPricing.map((item, index) => {
					priceForDays = priceForDays + Number(item.isSpecialPrice);
				});
			} else {
				priceForDays = Number(basePrice) * Number(dayDifference);
			}
		}
		let subTotal = total + serviceFee + securityDeposit;

		isAverage = Number(priceForDays) / Number(dayDifference);
		isDayTotal = isAverage.toFixed(2) * Number(dayDifference);
		priceForDays = isDayTotal;

		const promoCodeDetails = JSON.parse(dynamicPromoCodeDetails || '[]');
		const dynamicValue = getPromoCodeDetailsValue(promoCodeDetails, locale);

		return (
			<div>
				<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
					<div className={cx(cs.commonSmallText16, cs.textStart)}>
						<div className='tooltipFlex'>
							{isSpecialPriceAssigned && <ToolTipSection label={formatMessage(messages.averageRate)}
								tooltipIconClass={cx(cs.positionRelative, cs.top3)} />}
							<div>
								<CurrencyConverter amount={isAverage} from={currency} />
								{' x'} {dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
							</div>
						</div>
					</div>

					<div className={cx(cs.commonSmallText16, cs.textEnd)}>
						<CurrencyConverter
							amount={priceForDays}
							from={currency}
						/>
					</div>
				</div>

				{
					discount > 0 &&
					<div className={cx(cs.dataTableGrid, cs.paymentDivider, 'discountText')}>
						<div className={cx(cs.commonSmallText16, cs.textStart)}>{discountType}</div>
						<div className={cx(cs.commonSmallText16, cs.textEnd)}>
							<span>-&nbsp;
								<CurrencyConverter amount={discount} from={currency} />
							</span>
						</div>
					</div>
				}

				{
					promoDiscount > 0 &&
					<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
						<div className={cx(cs.commonSmallText16, cs.textStart)}>
							<div className="tooltipFlex">
								<ToolTipSection label={dynamicValue.description ? dynamicValue.description : promoCodeDescription} tooltipIconClass={cx(cs.positionRelative, cs.top3)} />
								<span className='discountText'>{promoCode}</span>
							</div>
						</div>
						<div className={cx(cs.commonSmallText16, cs.textEnd, 'discountText')}>
							<span>-&nbsp; <CurrencyConverter amount={promoDiscount} from={currency} /></span>
						</div>
					</div>
				}

				{
					delivery > 0 &&
					<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
						<div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.cleaningFee} /></div>
						<div className={cx(cs.commonSmallText16, cs.textEnd)}>
							<CurrencyConverter amount={delivery} from={currency} />
						</div>
					</div>
				}

				{
					serviceFee > 0 &&
					<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
						<div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.serviceFee} /></div>
						<div className={cx(cs.commonSmallText16, cs.textEnd)}>
							<CurrencyConverter amount={serviceFee} from={currency} />
						</div>
					</div>
				}

				{
					securityDeposit > 0 &&
					<div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
						<div className={cx(cs.commonSmallText16, cs.textStart)}><FormattedMessage {...messages.securityDeposit} /></div>
						<div className={cx(cs.commonSmallText16, cs.textEnd)}>
							<CurrencyConverter amount={securityDeposit} from={currency} />
						</div>
					</div>
				}

				<div className={cs.dataTableGrid}>
					<div className={cx(cs.commonSmallText16, cs.fontWeightMedium, cs.textStart)}><FormattedMessage {...messages.total} /></div>
					<div className={cx(cs.commonSmallText16, cs.fontWeightMedium, cs.textEnd)}>
						<CurrencyConverter amount={subTotal} from={currency} />
					</div>
				</div>
			</div >
		);
	}
}

export default injectIntl(withStyles(cs, s)(PaymentDetails));